var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('checkData',{key:_vm.$route.name},[_c('calendarPreview')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }